import moment from 'moment';

export enum EShakaPackagerJobStatus {
  Ready = 1,
  Processing = 2,
  Failed = 3,
  Success = 10,
}

export class ShakaPackagerJob {
  constructor(
    public jobUid: string,
    public mediaId: number,
    public mediaName: string,
    public createdAt: moment.Moment,
    public jobStatus: EShakaPackagerJobStatus,
    public lastJobStatusUpdate: moment.Moment,
    public sourcePath: string,
    public jobProcessLogPath: string | null,
    public fullMode: boolean,
  ) {}

  get hasProcessLog(): boolean {
    return !!this.jobProcessLogPath?.trim();
  }

  get statusDisplay(): string {
    const key = EShakaPackagerJobStatus[this.jobStatus];
    return typeof key === 'string' ? key : String(this.jobStatus);
  }
}

export interface ShakaPackagerProcessLogSummary {
  status?: string;
  mode?: string;
  videosBucketPath?: string;
  metadataBucketPath?: string;
  errors: string[];
  warnings: string[];
  stages: Array<{
    name: string;
    durationMs: number;
    status: string;
    errorMessage?: string;
  }>;
}
